// extracted by mini-css-extract-plugin
export default {"root":"Header_root__dD5pV","logo":"Header_logo__9QX2u","btn":"Header_btn__7bTCo","menu":"Header_menu__t4E20"};